import { Button, Result } from 'antd';
import { ErrorBoundary } from '../../core/errors/ErrorBoundary.tsx';

export interface IErrorBoundaryRoutesProps {
  children?: React.ReactNode;
  /** Basename del router (es. `/frontoffice/`), usato come href della home. */
  rootNavigationPath: string;
}

/**
 * Componente per gestire gli errori nelle Routes
 */
export function ErrorBoundaryRoutes(props: IErrorBoundaryRoutesProps) {
  const { children, rootNavigationPath } = props;

  return (
    <ErrorBoundary
      fallback={
        <Result
          status="error"
          title="Si è verificato un errore imprevisto"
          subTitle="Si è verificato un errore imprevisto durante il caricamento della pagina. Torna alla home."
          extra={[
            <Button type="primary" key="home" href={rootNavigationPath}>
              Torna alla home
            </Button>,
          ]}
        />
      }
    >
      {children}
    </ErrorBoundary>
  );
}
